// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* ── Patient & Order Info modal — mirrors the View Notes / Medical Notes look ── */
.order-info-container {
  --oi-border: #e3e6eb;
  --oi-muted: #6b7280;
  --oi-strong: #1f2937;
  --oi-accent: #0f766e; /* teal-700 */
  --oi-accent-soft: #ccfbf1; /* teal-100 */
  --oi-head-bg: #f3f5f8;
  font-size: 13px;
  /* ── Patient card ────────────────────────────────────────────────── */
  /* ── Panel section ───────────────────────────────────────────────── */
  /* ── Two-column labeled input grid (order information) ────────────── */
  /* ── Labeled field rows (priority, mlc, …) ───────────────────────── */
  /* First field row after the grid keeps a separating rule. */
  /* Medical-question labels wrap (they are full sentences), so widen them. */
  /* ── MLC extra info block ────────────────────────────────────────── */
  /* ── Item lookup matches ─────────────────────────────────────────── */
  /* ── Scans table ─────────────────────────────────────────────────── */
  /* ── Clinical notes ──────────────────────────────────────────────── */
  /* ── Footer / submit ─────────────────────────────────────────────── */
}
.order-info-container .oi-header {
  font-size: 0.95rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  color: #334155;
  margin-bottom: 10px;
}
.order-info-container .patient-card {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  column-gap: 18px;
  row-gap: 4px;
  padding: 8px 12px;
  margin-bottom: 12px;
  background: linear-gradient(180deg, #fbfcfe 0%, #f5f7fa 100%);
  border: 1px solid var(--oi-border);
  border-radius: 8px;
}
.order-info-container .pc-field {
  display: flex;
  flex-direction: column;
  min-width: 0;
  line-height: 1.25;
}
.order-info-container .pc-label {
  font-size: 0.68rem;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: var(--oi-muted);
}
.order-info-container .pc-value {
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--oi-strong);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.order-info-container .oi-panel {
  display: flex;
  flex-direction: column;
  border: 1px solid var(--oi-border);
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
  margin-bottom: 12px;
}
.order-info-container .oi-panel-head {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  background: var(--oi-head-bg);
  border-bottom: 1px solid var(--oi-border);
  font-size: 0.74rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #475569;
}
.order-info-container .oi-panel-head .anticon {
  color: var(--oi-accent);
}
.order-info-container .oi-panel-body {
  padding: 10px 12px;
}
.order-info-container .oi-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 18px;
  row-gap: 10px;
  margin-bottom: 6px;
}
.order-info-container .oi-grid-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}
.order-info-container .oi-grid-field.oi-grid-full {
  grid-column: 1/-1;
}
.order-info-container .oi-grid-label {
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  color: var(--oi-muted);
}
.order-info-container .oi-field {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  padding: 6px 0;
}
.order-info-container .oi-field + .oi-field {
  border-top: 1px solid #f1f3f6;
}
.order-info-container .oi-field-top {
  border-top: 1px solid #f1f3f6;
  margin-top: 6px;
}
.order-info-container .oi-med-label {
  min-width: 240px;
  text-transform: none;
  letter-spacing: normal;
  font-size: 0.78rem;
}
.order-info-container .oi-field-label {
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  color: var(--oi-muted);
  min-width: 132px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.order-info-container .oi-field-label .anticon {
  color: var(--oi-accent);
}
.order-info-container .ant-radio-wrapper .ant-radio-inner {
  border-color: #8f8c8c;
}
.order-info-container .ant-radio-wrapper:hover .ant-radio-inner {
  border-color: var(--oi-accent);
}
.order-info-container .ant-radio-wrapper-checked .ant-radio-inner {
  border-color: var(--oi-accent);
  background-color: var(--oi-accent);
}
.order-info-container .oi-mlc-extra {
  margin-top: 10px;
  padding: 12px;
  background: #fafafa;
  border: 1px solid var(--oi-border);
  border-radius: 8px;
}
.order-info-container .oi-mlc-extra .oi-mlc-label {
  margin-bottom: 4px;
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  color: var(--oi-muted);
}
.order-info-container .oi-link {
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--oi-accent);
  cursor: pointer;
}
.order-info-container .oi-link:hover {
  text-decoration: underline;
}
.order-info-container .oi-item-matches {
  margin-top: 10px;
  border: 1px solid var(--oi-border);
  border-radius: 8px;
  overflow: hidden;
}
.order-info-container .oi-item-empty {
  padding: 8px 12px;
  font-size: 0.78rem;
  color: var(--oi-muted);
}
.order-info-container .oi-item-match {
  display: grid;
  grid-template-columns: 120px 1fr 120px;
  column-gap: 12px;
  align-items: center;
  padding: 6px 12px;
  font-size: 0.8rem;
}
.order-info-container .oi-item-match + .oi-item-match {
  border-top: 1px solid #f1f3f6;
}
.order-info-container .oi-item-match .oi-item-code {
  font-weight: 700;
  color: var(--oi-strong);
}
.order-info-container .oi-item-match .oi-item-name {
  color: #475569;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.order-info-container .oi-item-match .oi-item-mods {
  font-weight: 600;
  color: var(--oi-accent);
  text-align: right;
}
.order-info-container .oi-scans {
  margin-top: 12px;
}
.order-info-container .oi-scans .ant-table-thead > tr > th {
  background: var(--oi-head-bg);
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  color: #475569;
}
.order-info-container .oi-scans .ant-table-tbody > tr > td {
  font-size: 0.8rem;
}
.order-info-container .oi-notes-label {
  display: block;
  margin: 12px 0 4px;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  color: var(--oi-muted);
}
.order-info-container .oi-actions {
  margin-top: 14px;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./pages/OrderInfo/order-info.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,mFAAA;AACA;EACE,oBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA,EAAA,aAAA;EACA,yBAAA,EAAA,aAAA;EACA,qBAAA;EACA,eAAA;EAUA,uEAAA;EAoCA,uEAAA;EA+BA,wEAAA;EA0BA,uEAAA;EAWA,4DAAA;EAMA,2EAAA;EA6BA,uEAAA;EA2BA,uEAAA;EAsCA,uEAAA;EAgBA,uEAAA;EAWA,uEAAA;AApOF;AAXE;EACE,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;EACA,mBAAA;AAaJ;AATE;EACE,aAAA;EACA,gDAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,6DAAA;EACA,kCAAA;EACA,kBAAA;AAWJ;AARE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,iBAAA;AAUJ;AAPE;EACE,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,sBAAA;AASJ;AANE;EACE,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAQJ;AAJE;EACE,aAAA;EACA,sBAAA;EACA,kCAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AAMJ;AAHE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,6BAAA;EACA,yCAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;AAKJ;AAHI;EAAW,uBAAA;AAMf;AAHE;EACE,kBAAA;AAKJ;AADE;EACE,aAAA;EACA,gDAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;AAGJ;AAAE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AAEJ;AAAI;EAAiB,iBAAA;AAGrB;AAAE;EACE,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,sBAAA;AAEJ;AAEE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,QAAA;EACA,cAAA;AAAJ;AAEI;EAAgB,6BAAA;AACpB;AAGE;EACE,6BAAA;EACA,eAAA;AADJ;AAKE;EACE,gBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;AAHJ;AAME;EACE,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,sBAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;AAJJ;AAMI;EAAW,uBAAA;AAHf;AAME;EAAsC,qBAAA;AAHxC;AAIE;EAA4C,8BAAA;AAD9C;AAEE;EACE,8BAAA;EACA,kCAAA;AAAJ;AAIE;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,kCAAA;EACA,kBAAA;AAFJ;AAII;EACE,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,sBAAA;AAFN;AAME;EACE,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;AAJJ;AAMI;EAAU,0BAAA;AAHd;AAOE;EACE,gBAAA;EACA,kCAAA;EACA,kBAAA;EACA,gBAAA;AALJ;AAQE;EACE,iBAAA;EACA,kBAAA;EACA,sBAAA;AANJ;AASE;EACE,aAAA;EACA,sCAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;AAPJ;AASI;EAAqB,6BAAA;AANzB;AAQI;EAAgB,gBAAA;EAAkB,uBAAA;AAJtC;AAKI;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAHN;AAKI;EACE,gBAAA;EACA,uBAAA;EACA,iBAAA;AAHN;AAQE;EACE,gBAAA;AANJ;AAQI;EACE,6BAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;AANN;AASI;EAA6B,iBAAA;AANjC;AAUE;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,sBAAA;AARJ;AAYE;EACE,gBAAA;EACA,kBAAA;AAVJ","sourcesContent":["/* ── Patient & Order Info modal — mirrors the View Notes / Medical Notes look ── */\r\n.order-info-container {\r\n  --oi-border: #e3e6eb;\r\n  --oi-muted: #6b7280;\r\n  --oi-strong: #1f2937;\r\n  --oi-accent: #0f766e;        /* teal-700 */\r\n  --oi-accent-soft: #ccfbf1;   /* teal-100 */\r\n  --oi-head-bg: #f3f5f8;\r\n  font-size: 13px;\r\n\r\n  .oi-header {\r\n    font-size: 0.95rem;\r\n    font-weight: 700;\r\n    letter-spacing: 0.04em;\r\n    color: #334155;\r\n    margin-bottom: 10px;\r\n  }\r\n\r\n  /* ── Patient card ────────────────────────────────────────────────── */\r\n  .patient-card {\r\n    display: grid;\r\n    grid-template-columns: repeat(4, minmax(0, 1fr));\r\n    column-gap: 18px;\r\n    row-gap: 4px;\r\n    padding: 8px 12px;\r\n    margin-bottom: 12px;\r\n    background: linear-gradient(180deg, #fbfcfe 0%, #f5f7fa 100%);\r\n    border: 1px solid var(--oi-border);\r\n    border-radius: 8px;\r\n  }\r\n\r\n  .pc-field {\r\n    display: flex;\r\n    flex-direction: column;\r\n    min-width: 0;\r\n    line-height: 1.25;\r\n  }\r\n\r\n  .pc-label {\r\n    font-size: 0.68rem;\r\n    text-transform: uppercase;\r\n    letter-spacing: 0.03em;\r\n    color: var(--oi-muted);\r\n  }\r\n\r\n  .pc-value {\r\n    font-size: 0.82rem;\r\n    font-weight: 600;\r\n    color: var(--oi-strong);\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n  }\r\n\r\n  /* ── Panel section ───────────────────────────────────────────────── */\r\n  .oi-panel {\r\n    display: flex;\r\n    flex-direction: column;\r\n    border: 1px solid var(--oi-border);\r\n    border-radius: 8px;\r\n    overflow: hidden;\r\n    background: #fff;\r\n    margin-bottom: 12px;\r\n  }\r\n\r\n  .oi-panel-head {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 6px;\r\n    padding: 6px 10px;\r\n    background: var(--oi-head-bg);\r\n    border-bottom: 1px solid var(--oi-border);\r\n    font-size: 0.74rem;\r\n    font-weight: 700;\r\n    text-transform: uppercase;\r\n    letter-spacing: 0.04em;\r\n    color: #475569;\r\n\r\n    .anticon { color: var(--oi-accent); }\r\n  }\r\n\r\n  .oi-panel-body {\r\n    padding: 10px 12px;\r\n  }\r\n\r\n  /* ── Two-column labeled input grid (order information) ────────────── */\r\n  .oi-grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, minmax(0, 1fr));\r\n    column-gap: 18px;\r\n    row-gap: 10px;\r\n    margin-bottom: 6px;\r\n  }\r\n\r\n  .oi-grid-field {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 4px;\r\n    min-width: 0;\r\n\r\n    &.oi-grid-full { grid-column: 1 / -1; }\r\n  }\r\n\r\n  .oi-grid-label {\r\n    font-size: 0.7rem;\r\n    font-weight: 700;\r\n    text-transform: uppercase;\r\n    letter-spacing: 0.02em;\r\n    color: var(--oi-muted);\r\n  }\r\n\r\n  /* ── Labeled field rows (priority, mlc, …) ───────────────────────── */\r\n  .oi-field {\r\n    display: flex;\r\n    align-items: center;\r\n    flex-wrap: wrap;\r\n    gap: 8px;\r\n    padding: 6px 0;\r\n\r\n    & + .oi-field { border-top: 1px solid #f1f3f6; }\r\n  }\r\n\r\n  /* First field row after the grid keeps a separating rule. */\r\n  .oi-field-top {\r\n    border-top: 1px solid #f1f3f6;\r\n    margin-top: 6px;\r\n  }\r\n\r\n  /* Medical-question labels wrap (they are full sentences), so widen them. */\r\n  .oi-med-label {\r\n    min-width: 240px;\r\n    text-transform: none;\r\n    letter-spacing: normal;\r\n    font-size: 0.78rem;\r\n  }\r\n\r\n  .oi-field-label {\r\n    font-size: 0.72rem;\r\n    font-weight: 700;\r\n    text-transform: uppercase;\r\n    letter-spacing: 0.02em;\r\n    color: var(--oi-muted);\r\n    min-width: 132px;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    gap: 4px;\r\n\r\n    .anticon { color: var(--oi-accent); }\r\n  }\r\n\r\n  .ant-radio-wrapper .ant-radio-inner { border-color: #8f8c8c; }\r\n  .ant-radio-wrapper:hover .ant-radio-inner { border-color: var(--oi-accent); }\r\n  .ant-radio-wrapper-checked .ant-radio-inner {\r\n    border-color: var(--oi-accent);\r\n    background-color: var(--oi-accent);\r\n  }\r\n\r\n  /* ── MLC extra info block ────────────────────────────────────────── */\r\n  .oi-mlc-extra {\r\n    margin-top: 10px;\r\n    padding: 12px;\r\n    background: #fafafa;\r\n    border: 1px solid var(--oi-border);\r\n    border-radius: 8px;\r\n\r\n    .oi-mlc-label {\r\n      margin-bottom: 4px;\r\n      font-size: 0.7rem;\r\n      font-weight: 700;\r\n      text-transform: uppercase;\r\n      letter-spacing: 0.02em;\r\n      color: var(--oi-muted);\r\n    }\r\n  }\r\n\r\n  .oi-link {\r\n    font-size: 0.78rem;\r\n    font-weight: 600;\r\n    color: var(--oi-accent);\r\n    cursor: pointer;\r\n\r\n    &:hover { text-decoration: underline; }\r\n  }\r\n\r\n  /* ── Item lookup matches ─────────────────────────────────────────── */\r\n  .oi-item-matches {\r\n    margin-top: 10px;\r\n    border: 1px solid var(--oi-border);\r\n    border-radius: 8px;\r\n    overflow: hidden;\r\n  }\r\n\r\n  .oi-item-empty {\r\n    padding: 8px 12px;\r\n    font-size: 0.78rem;\r\n    color: var(--oi-muted);\r\n  }\r\n\r\n  .oi-item-match {\r\n    display: grid;\r\n    grid-template-columns: 120px 1fr 120px;\r\n    column-gap: 12px;\r\n    align-items: center;\r\n    padding: 6px 12px;\r\n    font-size: 0.8rem;\r\n\r\n    & + .oi-item-match { border-top: 1px solid #f1f3f6; }\r\n\r\n    .oi-item-code { font-weight: 700; color: var(--oi-strong); }\r\n    .oi-item-name {\r\n      color: #475569;\r\n      white-space: nowrap;\r\n      overflow: hidden;\r\n      text-overflow: ellipsis;\r\n    }\r\n    .oi-item-mods {\r\n      font-weight: 600;\r\n      color: var(--oi-accent);\r\n      text-align: right;\r\n    }\r\n  }\r\n\r\n  /* ── Scans table ─────────────────────────────────────────────────── */\r\n  .oi-scans {\r\n    margin-top: 12px;\r\n\r\n    .ant-table-thead > tr > th {\r\n      background: var(--oi-head-bg);\r\n      font-size: 0.72rem;\r\n      font-weight: 700;\r\n      text-transform: uppercase;\r\n      letter-spacing: 0.02em;\r\n      color: #475569;\r\n    }\r\n\r\n    .ant-table-tbody > tr > td { font-size: 0.8rem; }\r\n  }\r\n\r\n  /* ── Clinical notes ──────────────────────────────────────────────── */\r\n  .oi-notes-label {\r\n    display: block;\r\n    margin: 12px 0 4px;\r\n    font-size: 0.72rem;\r\n    font-weight: 700;\r\n    text-transform: uppercase;\r\n    letter-spacing: 0.02em;\r\n    color: var(--oi-muted);\r\n  }\r\n\r\n  /* ── Footer / submit ─────────────────────────────────────────────── */\r\n  .oi-actions {\r\n    margin-top: 14px;\r\n    text-align: center;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
